export default __webpack_public_path__ + "static/media/dados_quantitativos.eaa0bf1f.svg";